<section class="block min-h-screen md:h-auto">
  <app-service-top-header
    class="block w-screen md:w-auto"
    [activeServices]="activeServices$ | async"
    [services]="services$ | async"
    [totalLocations]="totalActiveLocations$ | async"
    [isLoading]="isLoading$ | async"
  ></app-service-top-header>

  <div
    class="flex min-h-[calc(100vh-469px)] w-screen justify-between md:w-auto md:gap-6"
  >
    <app-inventory-list
      #inventoryList
      class="min-w-0 flex-1 p-4 md:ml-6 md:p-0"
      [services]="services$ | async"
      [isLoading]="isLoading$ | async"
      [selectedService]="selectedService$ | async"
      [groupedServices]="groupFilteredServices$ | async"
      [isServicesInProgress]="isServicesInProgress$ | async"
      [locationsFilterOptions]="locationsFilterOptions$ | async"
      [serviceFilterOptions]="serviceFilterOptions$ | async"
      [statusFilterOptions]="statusFilterOptions$ | async"
      [totalSelectedFilters]="totalSelectedFilters$ | async"
      (setSelectedService)="onSetSelectedService($event)"
      (setLoadingIndicator)="onLoadingIndicator()"
      [locationsFilterFormControl]="locationsFilterFormControl"
      [serviceFilterFormControl]="serviceFilterFormControl"
      [statusFilterFormControl]="statusFilterFormControl"
      [groupByFormControl]="groupByFormControl"
      [isAscFormControl]="isAscFormControl"
      [searchTermControl]="searchTermControl"
    ></app-inventory-list>

    <app-inventory-detail
      class="hidden min-w-0 flex-1 md:block"
      [services]="services$ | async"
      [selectedService]="selectedService$ | async"
      [activeServices]="activeServices$ | async"
      [isLoading]="isLoading$ | async"
      [isServicesInProgress]="isServicesInProgress$ | async"
    ></app-inventory-detail>
  </div>
</section>
